import { stickyContent } from '../utilities/sticky-content';

window.customPrice = function (data) {

    var $ = window.OsGlobals.jQuery;
    var activeClass = 'is-active';

    $(".product__final").show();
    $("h3.js-not-available").remove();

    if(data == null) {
        $(".product__final").hide(); 
        $(".product__final").parent().append("<h3 class='js-not-available'>Not available in this size</h3>");
        jQuery( '.js-show-instant-price-actions .btn__text' ).text( 'Get an instant price' );

        if (!$('.js-instant-price-actions').hasClass(activeClass)) {
            $('.js-instant-price-actions').slideDown().addClass(activeClass);
        }
        setTimeout( scrollAddToBasket, 500 );
        return;
    }

    
    var formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
    });

    jQuery( ".product__final-price" ).html( "Our price just: <span class='value'></span>" );

    if(data.discount > 0) {
        var was = data.originalPrice;
        var now = data.price;

        was = formatter.format(was);
        now = formatter.format(now);

        $(".product__final-price .value").empty().append("<del>"+was+"</del> "+now);

    } else {
        var from = formatter.format(data.price);
        $(".product__final-price .value").empty().append(from);
    }

    if (!$('.js-instant-price-actions').hasClass(activeClass)) {
        $('.js-instant-price-actions').slideDown().addClass(activeClass);
    }

    jQuery( '.js-show-instant-price-actions .btn__text' ).text( 'Get an instant price' );

    stickyContent();

    setTimeout( scrollAddToBasket, 500 );
}

function scrollAddToBasket() {
    let scrollThisMuch = $('.js-instant-price-actions').offset().top;
    let winScrollTop = $(window).scrollTop();
    let scrolledDown = winScrollTop > scrollThisMuch;

    console.log( '>>>', winScrollTop, scrolledDown, scrollThisMuch );

    console.log( scrollThisMuch, scrolledDown );

    if (scrolledDown) {
      $('html, body').animate({
        scrollTop: scrollThisMuch
      }, 500);
    }
}


window.newVariant = function (data) {
    console.log(data);

    window.variantId = data.product.variants[0].id;
    window.variantCreated = true;

    window.dynamicProperties = data.request.data;
    window.customerMeasurements = {
        'units':data.request['radio-measurement'],
        'width':data.request['field-min-width'],
        'drop':data.request['field-min-drop'],
    }

    var $ = window.OsGlobals.jQuery;

    $(".js-ajax-add").trigger('click');
}